// Helpers de date pour les champs <input type="date"> des vues chantier.
// IMPORTANT : ne JAMAIS passer par Date.prototype.toISOString() pour une date-seule — toISOString convertit
// en UTC et décale la date de ±1 jour pour tout fuseau à l'est de UTC (France CET/CEST). On manipule la chaîne.

// 'YYYY-MM-DD' à partir d'une date ISO / DateTimeOffset sérialisé, SANS conversion de fuseau.
export function toDateInput(iso) {
  if (!iso) return ''
  const m = /^(\d{4}-\d{2}-\d{2})/.exec(String(iso))
  return m ? m[1] : ''
}

// Date locale au format 'YYYY-MM-DD' (sans décalage de fuseau).
function localDateInput(d) {
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mm}-${dd}`
}

// Date du jour, locale, 'YYYY-MM-DD'.
export function todayDateInput() {
  return localDateInput(new Date())
}

// Il y a N jours, date locale, 'YYYY-MM-DD'.
export function daysAgoDateInput(n) {
  const d = new Date()
  d.setDate(d.getDate() - n)
  return localDateInput(d)
}
